export default __webpack_public_path__ + "static/media/justokEmoji.eae08be5.svg";